import { render, staticRenderFns } from "./Dispensations.vue?vue&type=template&id=bb5f9a8c&scoped=true"
import script from "./Dispensations.vue?vue&type=script&lang=js"
export * from "./Dispensations.vue?vue&type=script&lang=js"
import style0 from "./Dispensations.vue?vue&type=style&index=0&id=bb5f9a8c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5f9a8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb5f9a8c')) {
      api.createRecord('bb5f9a8c', component.options)
    } else {
      api.reload('bb5f9a8c', component.options)
    }
    module.hot.accept("./Dispensations.vue?vue&type=template&id=bb5f9a8c&scoped=true", function () {
      api.rerender('bb5f9a8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/specialists/management/components/dispensation-tab/Dispensations.vue"
export default component.exports